import moment from "moment";
import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setRemedyRequest } from "../../../../controller/reducer/remedy";
import TagDisplay from "../../common/tags";
import "./styles.css";

function truncate(str, n) {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
}

function RemedyCard({ dispatch, remedy }) {
  return (
    <Card border="info" className="remedy-card" style={{ minWidth: "18rem" }}>
      <p
        className={`h6 bg-${
          remedy.type === "add" ? "success" : "info"
        } text-light text-center p-1`}
      >
        {remedy.type === "add" ? "ADD NEW RESOURCE" : "EDIT EXISTING RESOURCE"}
      </p>
      <Card.Body>
        <Card.Title
          className="text-center h5 font-weight-normal"
          as={Link}
          to={"/admin/remedy"}
          onClick={() => dispatch(setRemedyRequest(remedy))}
        >
          {truncate(remedy.title, 90)}
        </Card.Title>
        <TagDisplay tags={remedy.tags} />
      </Card.Body>
      <Card.Footer className="text-muted">
        Updated {moment(remedy.updated).fromNow(true)} ago
      </Card.Footer>
    </Card>
  );
}

export default RemedyCard;
